import React, { useState } from 'react';
interface IModalCommon {
    handleClose?: any;
    handleSaveTicket: any;
    savingTicket: boolean;
}
const CreateTicket: React.FC<IModalCommon> = ({ handleClose, handleSaveTicket, savingTicket }) => {
  const [ name, setName ] = useState('');

  const handleTypeName = (e: any) => {
    setName(e.target.value);
  };


  return (
    <div className='audit-add-modal-cont'>
      <div className='audit-add-modal-cont-head'>
        <div className='audit-add-modal-head-cont-change' style={{ padding: '16px var(--spacing-3xl, 24px)' }}>
          <div className='audit-add-modal-head-cont-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
              <path d='M9 3.75V14.25M3.75 9H14.25' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='audit-add-modal-head-cont-supporting' style={{ paddingTop: '10px' }}>
            <h1>Create Ticket</h1>
          </div>
        </div>
        <div className='audit-add-modal-head-close' onClick={handleClose}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#85888E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
      { savingTicket ?
        <div className='bill-container-fit-screen-content'>
          <div className='loading-spinner-cont-modal'>
            <svg className='spinner' xmlns='http://www.w3.org/2000/svg' width='32' height='33' viewBox='0 0 32 33' fill='none'>
              <g clipPath='url(#clip0_4006_13811)'>
                <circle cx='16' cy='3.75' r='3' fill='white' fillOpacity='0.1'/>
                <circle opacity='0.45' cx='16' cy='29.75' r='3' fill='white' fillOpacity='0.65'/>
                <circle cx='3' cy='16.75' r='3' fill='white' fillOpacity='0.85'/>
                <circle cx='29' cy='16.75' r='3' fill='white' fillOpacity='0.35'/>
                <circle cx='26' cy='7.75' r='3' fill='white' fillOpacity='0.25'/>
                <circle cx='26' cy='25.75' r='3' fill='white' fillOpacity='0.45'/>
                <circle cx='6' cy='25.75' r='3' fill='white' fillOpacity='0.75'/>
                <circle cx='6' cy='7.75' r='3' fill='white'/>
              </g>
              <defs>
                <clipPath id='clip0_4006_13811'>
                  <rect width='32' height='32' fill='white' transform='translate(0 0.75)'/>
                </clipPath>
              </defs>
            </svg>
            <p>Saving Ticket...</p>
          </div>
        </div> :
        <div className='audit-add-modal-cont-body' style={{ paddingTop: '12px', paddingBottom: '12px' }}>
          <div className='audit-add-modal-cont-body-frame'>
            <div className='audit-add-modal-cont-body-frame-form'>
              <div className='audit-add-modal-cont-body-frame-form-row'>
                <div className='audit-add-modal-cont-body-frame-form-row-input'>
                  <div className='audit-add-modal-cont-body-frame-form-row-input-label'>
                    <div className='audit-add-modal-cont-body-frame-form-row-input-label-text'>
                    Ticket name
                    </div>
                    <input className='audit-add-modal-cont-body-frame-form-input' type='text' placeholder='e.g. Clothing Classification' value={name} onChange={(e) => {
                      handleTypeName(e);
                    }}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
      <div className='audit-modal-cont-footer'>
        <div className='audit-modal-cont-footer-content'>
          <div className='audit-modal-cont-footer-content-btn-cancel' onClick={handleClose}>
            <div className='audit-modal-cont-footer-content-btn-text'>
                Cancel
            </div>
          </div>
          {name.length === 0 || !name || savingTicket ?
            <div className='classify-container-footer-btn-save'>
              <div className='classify-container-footer-btn-result-text'>
                    Save
              </div>
            </div> :
            <div className='active-save-btn'
              onClick={() => handleSaveTicket(name)}>
              <div className='active-text'>
                  Save
              </div>
            </div>
          }
          {/* <div className='audit-modal-cont-footer-content-btn-upload' onClick={() => {
            handleSaveTicket(name);
          }}>
            <div className='audit-modal-cont-footer-content-btn-text'>
                Save
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CreateTicket;
